/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_372a21e9"]'><div :class='["dialog-show-close-demo"]'><cube-button @_click="onClickDialog">Dialog - with close icon</cube-button><cube-dialog ref="__mpx_ref_dialogWithCloseIcon__" :show-close="(true)" icon="alert" cancel-btn="取消" confirm-btn="确认"><div slot="title">测试标题</div><div slot="content" :class='["dialog-show-close-content"]'>测试content</div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_372a21e9"}'>
.dialog-show-close-content
  text-align center
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_372a21e9"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_372a21e9"}
  /** script content **/
  require("./dialog-show-close.mpx.js?isComponent&outputPath=components%2Fdialog-show-close372a21e9%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-show-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-show-close372a21e9%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_372a21e9"],
    ctorType: "component",
    outputPath: "components/dialog-show-close372a21e9/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>